import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {RoutesConfig} from '@employee-configs/routes.config';
import {AppConfigurationService} from '@ui-app/services/app-configuration.service';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import * as SharedModels from '@ui-app/models';

@Injectable({
    providedIn: 'root'
})
export class IndividualRequestPageGuard implements CanActivate {

    constructor(
        private router: Router,
        private appConfigService: AppConfigurationService
    ) {
    }

    canActivate(): Observable<true | UrlTree> {
           return this.appConfigService.getConfiguration().pipe(
                switchMap(configuration => this.appConfigService.isSettingEnabled$(SharedModels.CE.AppConfigurationSettings.IsIndividualMobileBadgeEnabled)),
                map((isIndividualMobileBadgeEnabled) => {
                    return isIndividualMobileBadgeEnabled || this.router.createUrlTree(['/', RoutesConfig.general.accessDeniedPage]);
                })
            );
    }
}
